var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function PaginateLoadMore(el) {
    var t = this;

    t.$el = $(el);
    t.$button = t.$el.children(".paginate-load-more-button");
    t.ajaxSelector = t.$button.data("ajax");
    t.anchor = t.$button.data("target");
    
    if (t.ajaxSelector) {
        t.$currentContent = $(t.ajaxSelector);
        t.$button.on("click", function (e) {
            e.preventDefault();

            $.get(
                t.$button.attr("href"),
                function (data) {
                    var $newDoc = $($.parseHTML(data, document)),
                        $newContent = $newDoc.find(t.ajaxSelector).children(),
                        // assuming there's only one load more button per page
                        $newButton = $newDoc.find(".paginate-load-more-button");

                    $(t.anchor).append($newContent.html());

                    if ($newButton.length) {
                        t.$button.attr("href", $newButton.attr("href"));
                    } else {
                        t.$button.remove();
                    }
                }
            );
        });
    }
}

module.exports = PaginateLoadMore;
